<!-- src/components/FooterGlobal.vue -->
<template>
<footer>
    <div class="container-big">
        <div class="left columns three logo-footer-wrap"><a href="/" class="logo-header"><img src="/images/logo-vicapital.svg" alt="Vicapital" /></a></div>
                                        
        <div class="right columns three offset-by-five">
            <div class="datos-contacto">
                <h3><a href="/contacto">CONTACTO</a></h3>
                <a href="tel:+562 2233 6060">Tel +562 2233 6060</a>
                <a href="mailto:contacto@vicapital.cl">contacto@vicapital.cl</a>
                <p>Alonso de Córdova 3788, Oficina 63-B, Vitacura, Santiago</p>
            </div>
                <a href="https://www.cmfchile.cl/institucional/mercados/entidad.php?mercado=O&amp;rut=76237107&amp;grupo=&amp;tipoentidad=RGPSF&amp;row=&amp;vig=VI&amp;control=svs&amp;pestania=1" target="_blank" rel="noopener nofollow" class="link-cmf mobile"><img src="/images/logo_cmf_chico.svg" alt="Registro CMF" /></a>
                <a href="/documentos/Codigo-de-Conducta-Vicapital-SpA.pdf" target="_blank" class="download-codigo mobile">Código de Conducta</a>
        </div>
            <div class="right columns one codigo-conducta desk">
                <a href="https://www.cmfchile.cl/institucional/mercados/entidad.php?mercado=O&amp;rut=76237107&amp;grupo=&amp;tipoentidad=RGPSF&amp;row=&amp;vig=VI&amp;control=svs&amp;pestania=1" target="_blank" rel="noopener nofollow" class="link-cmf"><img src="/images/logo_cmf_chico.svg" alt="Registro CMF" /></a>
                <a href="/documentos/Codigo-de-Conducta-Vicapital-SpA.pdf" target="_blank" class="download-codigo">Código de Conducta</a>
            </div>
    </div>
</footer>
</template>

<script>
export default {
  name: 'FooterGlobal'
}
</script>

<style scoped></style>
